import { InterviewNowFlair } from './InterviewNowFlair';
import { getInterviewNowButtonText, getIndeedApplyButtonText } from './useInterviewNow';
import { Divider, Box, Text, Heading } from '../../../../../../mads';
import { useI18n } from '../../../../../../shared/I18n';
import { logScreenView } from '../../../../../../shared/native-modules/tare/logScreenView';

import { colors } from '@indeed/ifl-tokens';
import React, { useLayoutEffect, useRef } from 'react';
import { StyleSheet } from 'react-native';

const customStyles = StyleSheet.create({
    flairContainer: {
        marginTop: 8,
    },
    topDividerContainer: {
        marginTop: 20,
    },
    mainContainer: {
        marginVertical: 24,
        paddingHorizontal: 4,
        display: 'flex',
        flexDirection: 'column',
    },
    subtitleText: {
        marginTop: 8,
        fontWeight: '700',
    },
    contentText: {
        marginTop: 8,
        color: colors.neutral['700'],
        fontWeight: '400',
    },
});

export const InterviewNowDetails: React.FC = ({}) => {
    const i18n = useI18n();
    const headingText = i18n.pgettext('Section header', 'Interview details');
    const subtitleText = i18n.gettext(
        // # Subtitle for interview now content section.
        'A recruiter is online right now interviewing candidates',
    );
    const contentText = i18n.gettext(
        // # Instructions for interview now content section - {0} Button text for Interview now CTA - {1} Button text for Apply CTA
        'After clicking "{0}" below and submitting your application, you may have the opportunity to answer screener questions from the employer and potentially connect directly with their recruiter for a video interview. If you prefer to proceed with the standard application process instead, please select "{1}".',
        [getInterviewNowButtonText(i18n), getIndeedApplyButtonText(i18n)],
    );

    const hasLoggedImpression = useRef(false);

    useLayoutEffect(() => {
        if (!hasLoggedImpression.current) {
            hasLoggedImpression.current = true;
            logScreenView('rn-view-job-interview-now-details-seen').catch(console.error);
        }
    }, []);

    return (
        <>
            <Box sx={customStyles.topDividerContainer}>
                <Divider />
            </Box>
            <Box sx={customStyles.mainContainer}>
                <Heading level={4}>{headingText}</Heading>
                <InterviewNowFlair
                    displayText={i18n.gettext('Recruiter online now')}
                    containerStyle={customStyles.flairContainer}
                />
                <Text level={3} sx={customStyles.subtitleText}>
                    {subtitleText}
                </Text>
                <Text level={2} sx={customStyles.contentText}>
                    {contentText}
                </Text>
            </Box>
        </>
    );
};
